<template>
  <div>
    <el-card class="box-card fixed-element">
      <div class="button_box">
        <el-button type="primary" size="medium" v-for="(item, i) in messageSortButtons" @click="filterMessage(i)"
                   :key="i" :class="buttonIndex === i ? 'button_color1' : 'button_color0'" style="width: 30%">{{
            item
          }}
        </el-button>
      </div>
      <el-row :gutter="20" style="margin:3px 0;padding:6px;background-color:#323a6b;color:#fff;">
        <el-col :span="4">状态</el-col>
        <el-col :span="15">内容</el-col>
        <el-col :span="5">时间</el-col>
      </el-row>
    </el-card>
    <el-card class="box-card box-card-down">
      <ul ref="ulMessage" class="">
        <li v-for="message in viewPr" :key="message.id" class="" style="font-size:12px;" @click="rowClick(message)">
          <el-row :gutter="20" style="background-color:#d2d9f1;margin: 0 0 6px 0;border-radius:4px;padding:6px 0;">
            <el-col :span="4">
              <el-badge is-dot class="mark" v-if="message.status === 10"/>
              {{ parseStatus(message.status) }}
            </el-col>
            <el-col :span="14">
              <span>{{ message.content }}</span>
            </el-col>
            <el-col :span="6">
              <span>{{ message.createTime }}</span>
            </el-col>
          </el-row>
        </li>
      </ul>
      <!--      <el-pagination background layout="prev, pager, next" :total="pr.totalCount"-->
      <!--                     @current-change="currentPageChange"></el-pagination>-->

    </el-card>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import HttpRequest from "@/utils/request";

export default {
  name: "mainpage",
  data() {
    return {
      pr: [],
      viewPr: [],
      pageNo: 1,//当前页
      pageSize: 6,
      buttonIndex: 1,
      messageSortButtons: ['全部', '未读', '已读'],
    };
  },
  computed: {
    ...mapState({
      student: state => state.user.student,
    }),
  },
  created() {
    this.getPageSmsByWhile();
  },
  mounted() {
    document.title = '消息'
  },
  methods: {
    parseStatus(status) {
      return status === 10 ? '未读' : status === 12 ? '已读' : '';
    },
    getPageSmsByWhile() {
      let url1 = "/constub/getSms";
      let data1 = {token: this.student.token};
      HttpRequest.requestFormPost(url1, data1).then((res) => {
        if (res && res.result.success) {
          this.pr = res.data;
          this.filterMessage(this.buttonIndex)
        } else {
          this.$alert(res.result.message, {confirmButtonText: '确定', showClose: false,});
        }
      });
      // return
      // let url = "/constub/getPageSmsByWhile";
      // let data = {token: this.student.token, pageNo: this.pageNo, pageSize: this.pageSize};
      // HttpRequest.requestFormPost(url, data).then((res) => {
      //   if (res && res.result.success) {
      //     this.pr = res.data;
      //   } else {
      //     this.$alert(res.result.message, {confirmButtonText: '确定', showClose: false,});
      //   }
      // });
    },
    currentPageChange(currentPage) {
      this.pageNo = currentPage;
      this.getPageSmsByWhile();
    },
    rowClick(message) {
      if (message.status === 10) {
        let url = "/constub/readSms";
        let data = {token: this.student.token, smsId: message.id,};
        HttpRequest.requestFormPost(url, data).then((res) => {
          if (res && res.result.success) {
            this.getPageSmsByWhile();
          } else {
            this.$alert(res.result.message, {confirmButtonText: '确定', showClose: false,});
          }
        });
      }
    },
    filterMessage(status) {
      this.buttonIndex = status;
      if (status === 0) {
        this.viewPr = this.pr
      } else {
        let s = status === 1 ? 10 : 12
        this.viewPr = this.pr.filter(q => q.status === s);
      }
      //0 全部
      //1 未读
      //2 已读
    },
  },
};
</script>

<style scoped>
.el-pagination {
  text-align: center;
  position: fixed;
  bottom: 80px;
  width: 100%;
}

.box-card {
  padding: 5px;
}

.button_box {
  text-align: center;
  padding: 10px;
}

.button_box button {
  width: 30%;
}

.button_color0 {
  background-color: #D2D9F1;
  border-color: snow;
  color: #000;
}

.button_color1 {
  background-color: #409DFD;
  border-color: snow;
  color: #FFF;
}

.fixed-element {
  z-index: 998;
  position: fixed;
  top: 0;
  left: 0;
  margin: 10px;
  width: calc(100% - 20px);
}

.box-card-down {
  z-index: 999;
  position: fixed;
  top: 106px;
  left: 0;
  margin: 10px;
  width: calc(100% - 20px);
  height: calc(100% - 185px);
  overflow: auto;
}
</style>
